import { LoadingIndicator } from '@waves/loading-indicator';
import React, { ReactElement } from 'react';

import { KitWavesLoadingIndicatorProps } from './types';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'waves-loading-indicator': {
        color: 'default' | 'white';
        size: 'sm' | 'md';
        speed: 'slow' | 'default';
      };
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (!window.customElements.get('waves-loading-indicator')) {
    window.customElements.define('waves-loading-indicator', LoadingIndicator);
  }
}

export const KitWavesLoadingIndicator = ({
  color = 'default',
  size = 'md',
  speed = 'default',
}: KitWavesLoadingIndicatorProps): ReactElement => {
  return <waves-loading-indicator color={color} size={size} speed={speed} />;
};
